const POP_UP_COOKIE_NAME = 'pop_up';
const POP_UP_COOKIE_DAYS = 365;

let $profileChoice;

function setCookie(name, value, days) {
    let expires = '';
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${value}${expires}; path=/`;
}

function getCookie(name) {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i += 1) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

function closePopUp() {
    if ($profileChoice.hasClass('is-active')) {
        $profileChoice.removeClass('is-active');
    }
}

function initPopUp() {
    const popupId = $profileChoice.data('id');
    const cookieName = POP_UP_COOKIE_NAME + '-' + popupId;
    
    if (!getCookie(cookieName)) {
        setCookie(
            cookieName,
            true,
            POP_UP_COOKIE_DAYS,
        );

        $profileChoice.addClass('is-active');
    }
}

$(document).ready(() => {
    $profileChoice = $('.js-pop-up');

    if ($profileChoice.length) {
        initPopUp();
    }
});


